import { IUsuarioModel } from '@/models/usuario/UsuarioModel';
import http from './ApiConfig';
import { Service } from './Service';
import { IVerificacaoSenhaCertificadoDigital } from '../models/AssinaturaDigital/VerificacaoSenhaCertificadoDigital';

export class UsuarioService extends Service {
  constructor() {
    super('usuarios');
  }

  public GetAllPaginado(nomeOuId: string, limit: number, page: number) {
    return http.get(`${this._nomeControle}?nomeOuId=${nomeOuId}&limit=${limit}&page=${page}`, this.GetHeader());
  }

  public obterTodosOsRegistrosSemPaginacao(termoPesquisado: string) {
    const url = `${this._nomeControle}/lista-usuarios-sem-paginacao`;
    const configuracoes = {
      ...this.GetHeader(),
      params: { nomeOuId: termoPesquisado },
    };
    return http.get(url, configuracoes);
  }

  public obterAdministradoresDaClinica() {
    return http.get(`${this._nomeControle}/administradores`, this.GetHeader());
  }

  public MudarTema() {
    return http.put(`${this.GetNomeControle()}/MudarTema`, this.GetHeader());
  }

  public Delete(id: number) {
    return http.delete('usuario/usuarioId', this.GetHeader());
  }

  public ListarUsuariosParaLog() {
    return http.get(`${this._nomeControle}/listar-usuarios`, this.GetHeader());
  }

  public BuscarUsuarioAdminPeloEmail(email: string) {
    return http.get(`${this._nomeControle}/buscar-usuario-admin-pelo-email/${email}`, this.GetHeader());
  }

  public BuscarHost() {
    return http.get(`${this._nomeControle}/listar-usuario-host`, this.GetHeader());
  }

  public AtivarOuInativarStatus(id: string, ativo: boolean) {
    return http.patch(
      `${this._nomeControle}/${id}/ativar-ou-inativar-status`,
      ativo,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
  }

  async uploadCertificadoDigital(data: IUsuarioModel) {
    return http.put(`${this._nomeControle}/upload-certificado-digital-s3`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
        ...this.GetHeader().headers,
      },
    });
  }

  async cadastrarCertificadoDigital(data: IUsuarioModel) {
    return http.post(`${this._nomeControle}/cadastrar-certificado-digital-s3`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
        ...this.GetHeader().headers,
      },
    });
  }

  async verificarSenhaCertificadoDigital(form: FormData) {
    return http.post(`${this._nomeControle}/validar-senha-certificado`, form, {
      headers: {
        ...this.GetHeader().headers,
      },
    });
  }

  public getCertificadoDigitalDoUsuario(usuarioId:number) {
    return http.get(`${this._nomeControle}/listar-certificados/${usuarioId}`, this.GetHeader());
  }

  public excluirCertificadoDigital(usuarioId: string) {
    return http.delete(`${this._nomeControle}/excluir-certificado/${usuarioId}`, this.GetHeader());
  }

  public async getCrmsMedicoLogado() {
    return http.get(`${this._nomeControle}/crms-medico-logado`, this.GetHeader());
  }
}
